<template>
  <a @click.prevent="clickEvent" href="#">
    <div class="picture-area">
      <WebpImage :imageInfo="{imageUrl: backgroundImg, width: getWidth, height: getHeight, alt: altTitle, className: 'big-banner'}"/>
      <WebpImage :imageInfo="{imageUrl: textImg, width: getWidth, height: getHeight, className: 'big-banner-title'}"/>
    </div>
  </a>
</template>

<script>
import { resizeThumbnail } from '@/common/image.filter'
import { get } from 'lodash'
import { getEventListByType } from '@/common/util/event.util'
import { parseUrl, stringify } from 'query-string'
import WebpImage from '@/components/image/WebpImage'
import { replaceUrl } from '@/common/util/common'
const PORTRAIT = 'portrait'
const LANDSCAPE = 'landscape'
export default {
  name: 'BannerTextItem',
  components: { WebpImage },
  props: ['bannerInfo'],
  filters: {
    resizeThumbnail
  },
  computed: {
    mobileWidthStatus () {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      const portrait = get(window.matchMedia('(orientation: portrait)'), 'matches', false)
      const landscape = get(window.matchMedia('(orientation: landscape)'), 'matches', false)

      if ((w > 767 && portrait) || (w > 1023 && landscape)) {
        return LANDSCAPE
      } else {
        return PORTRAIT
      }
    },
    backgroundImg () {
      if (this.mobileWidthStatus === LANDSCAPE) {
        return get(this.bannerInfo, 'image.landscape_large.background', '')
      } else {
        return get(this.bannerInfo, 'image.portrait.background', '')
      }
    },
    textImg () {
      if (this.mobileWidthStatus === LANDSCAPE) {
        return get(this.bannerInfo, 'image.landscape_large.text', '')
      } else {
        return get(this.bannerInfo, 'image.portrait.text', '')
      }
    },
    altTitle () {
      return get(this.bannerInfo, 'title_list.0.text', '')
    },
    getWidth () {
      return this.mobileWidthStatus === LANDSCAPE ? 1240 : 375
    },
    getHeight () {
      return this.mobileWidthStatus === LANDSCAPE ? 508 : 480
    }
  },
  methods: {
    clickEvent () {
      const { onNavigationEvent } = getEventListByType(get(this.bannerInfo, 'event_list', []))
      const { url, query } = parseUrl(get(onNavigationEvent, 'url', ''))
      let newUrl = replaceUrl(url)
      this.$router.push(newUrl + '?' + stringify(query))
    },
    getThumbnailImg (image, width, height) {
      return resizeThumbnail(image, { width, height })
    }
  }
}
</script>
<style lang="scss">
.picture-area {
  width: 100%;
  height: 100%;
}
</style>
